<template>
  <component
    :is="demande"
    class="dispositif"
  ></component>
</template>

<script lang="ts" setup>
  import { computed, type Component } from 'vue'
  import { useRouter } from 'vue-router'
  import type { Dispositif } from '@/features/domaine/types/opco'
  import demandeCAPP from './capp/DemandeCAPP.vue'
  import demandeAF from './af/DemandeAF.vue'
  import demandeCPRO from './cpro/DemandeCPRO.vue'
  import demandePROA from './proa/DemandePROA.vue'

  const router = useRouter()

  const disposifs: { [key in Dispositif]: Component } = {
    CAPP: demandeCAPP,
    AF: demandeAF,
    CPRO: demandeCPRO,
    PROA: demandePROA,
  }

  const demande = computed(() => {
    const disposif = (router.currentRoute.value.params['dispositif'] as string).toUpperCase() as Dispositif
    return disposifs[disposif]
  })
</script>
<style scoped lang="less">
  .dispositif {
    height: 100%;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
</style>
<style lang="less">
  @import './shared/ListeDispositifElements.less';

  .help-btn {
    border-radius: 50%;
    transform: scale(0.5) translateX(-10px);
    transition: transform 0.3s;
    min-width: 40px;
  }
  .help-btn :deep(span) {
    font-size: 1.4rem;
  }
  .help-btn:hover {
    transform: scale(0.8) translateX(-4px);
  }
</style>
